// export const basicURL = "https://core-dev.microlab.help/api/";
export const basicURL = "https://core.microlab.help/api/";
// const browserHost =
//   typeof window !== "undefined" ? window.location.hostname : "localhost";
// const isLanOrLocalHost =
//   browserHost === "localhost" ||
//   browserHost === "127.0.0.1" ||
//   browserHost === "0.0.0.0" ||
//   /^192\.168\./.test(browserHost) ||
//   /^10\./.test(browserHost) ||
//   /^172\.(1[6-9]|2\d|3[0-1])\./.test(browserHost);

// export const basicURL =
//   process.env.REACT_APP_API_BASE_URL ||
//   (isLanOrLocalHost
//     ? `http://${browserHost}:4000/api/`
//     : "https://api.microlab.help/api/");

export const loginURL = "auth/login";
export const socialAuthURL = "auth/social_auth";
/** GET: send OTP — same contract as the mobile app (`auth/verification`). */
export const verificationURL = "auth/verification";
export const recoverPasswordURL = "auth/recover_password";
export const authURL = "auth";
export const userURL = "user/all";
export const getTitleURL = "title/json";
export const updatePresentationPublishURL = "title/presentation/publish";
export const getLibraryURL = "title/library";
export const libraryReferenceURL = "title/library/reference";
export const libraryVisibilityURL = "title/library/visibility";
export const getPackageURL = "payment/package";
export const getTransactionsURL = "payment/transaction";
/** Admin: subscription cancel survey rows */
export const subscriptionCancellationSurveysURL =
  "payment/subscription/cancellation-surveys";
export const addTitleURL = "title/title";
export const addSubTitleURL = "title/sub_title";
export const addSlideURL = "title/slide";
export const addSlideFileURL = "file/upload";
export const deleteSlideFileURL = "file";
export const getSlideByIdURL = "title/getSlideById";
export const addPinURL = "title/pin";
export const editPinURL = "title/pin";
export const deletePinURL = "title/pin";
export const swapTitleURL = "title/swapTitleOrder";
export const revenueCatSubscriptionsURL = "report/revenuecat/subscriptions";

export const quizTitleURL = "quiz/title";
export const quizContentURL = "quiz/content";
export const quizContentRandomURL = "quiz/contentRandom";
export const quizResultURL = "quiz/result";
export const getQuizResultGroupByDateURL = "quiz/getQuizResultGroupByDate";

// Professor titles (for quiz / question bank)
export const quizProfessorTitlesURL = "quiz/professor-titles";

// New quiz system (question bank + assignments + attempts)
export const quizQuestionBankURL = "quiz/question-bank";
export const quizAssignmentsURL = "quiz/assignments";
export const quizAssignedURL = "quiz/assigned";
export const quizAttemptsStartURL = "quiz/attempts/start";
export const quizAttemptsStartByCodeURL = "quiz/attempts/start-by-code";
export const quizAttemptsSubmitURL = "quiz/attempts/submit";
export const quizAttemptsMyURL = "quiz/attempts/my";
export const quizAttemptsResultURL = "quiz/attempts/result";
export const quizByTileURL = "quiz/by-tile";
export const quizBySlideURL = "quiz/by-slide";
export const quizLinkedIdsURL = "quiz/linked-ids";
export const quizHeatmapURL = "quiz/heatmap";
export const quizResultsURL = "quiz/results";
export const pushURL = "notification";
export const editTitleImageCallURL = "title/updateTitleImage";
export const getReportURL = "report/dashboard-stats";
export const getMapReportURL = "report/dashboard-map";
export const getProfStatsURL = "report/prof-stats";
export const getStorageSummaryURL = "report/storage-summary";
export const getDeviceHostsReportURL = "report/device-hosts";
export const getAddSlidePresentationURL = "universities/slides";
export const getAddSlidePresentationByTitleIdURL = "universities/slides-by-title";
export const getPublicSlidePresentationByTitleIdURL = "universities/public/slides-by-title";
export const getAddContentToSlidePresentationURL = "universities/slides/content";
export const universitiesURL = "universities";
export const getProfsForDropdownURL = "universities/profs";
export const aiGenerateQuestionURL = "ai/generate-question";
export const aiQuizInsightsURL = "ai/quiz-insights";
export const aiAskURL = "ai";
export const aiThreadMessagesURL = "ai";

/** Demo request funnel (Quiz) — saves row + emails admins (see DEMO_REQUEST_NOTIFY_EMAILS) */
export const demoRequestURL = "demo-request";

// Affiliation / earning (admin: earners list + sales progress)
export const affiliationEarnersURL = "affiliation/earners";
export const affiliationEarnerSalesURL = "affiliation/earners";

// Community ads (sponsored videos shown in community feed)
export const communityAdsURL = "question/ads";
export const allQuestionURL = "question";
export const myQuestionURL = "question/me";
export const publicURL = "public/public";
